<template>
  <b-modal id="productDetailsModal" :title="this.$t('product_info.product_info')" centered size="xl" :hide-footer="true" :header-class="'pt-4'" :header-border-variant="'light'">
    <template #modal-header>
      <div class="px-4">
        <h6 class="mt-3">{{ $t('product_info.product_info') }}</h6>
      </div>
      <div class="mr-4">
        <button class="btn btn-gray btn-close" @click="hideModal"><x-icon></x-icon></button>
      </div>
    </template>
    <div class="px-4">
      <table class="table table-striped table-bordered">
        <thead class="thead-light">
          <th>{{ $t('product_info.field_name') }}</th>
          <th>{{ $t('product_info.field_value') }}</th>
          <th>{{ $t('product_info.source') }}</th>
        </thead>
        <tbody>
          <tr v-for="(value, key) in productData" v-bind:key="key">
            <td>{{ key.substr(0, key.indexOf('—') - 1) }}</td>
            <td class="break-text">{{ value }}</td>
            <td>
              <img class="icon-small mx-4" v-bind:src="'/app/images/icons/sources/'+getProductPropertySource(key)+'.svg'" />{{ key.substr(key.indexOf('—') + 1, key.length - 1) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </b-modal>
</template>

<script>
import { XIcon } from 'vue-feather-icons'

export default {
  name: 'ProductDetailsModal',

  data () {
    return {
      //
    }
  },

  props: {
    productData: { required: false, type: Object },
    sources: { required: false, type: Array }
  },

  methods: {
    hideModal () {
      this.$root.$emit('bv::hide::modal', 'productDetailsModal')
    },

    getProductPropertySource (propertyName) {
      return this.sources.filter(source => source.name.includes(propertyName.substr(propertyName.indexOf('—') + 2, propertyName.length - 1)))[0].config.fileType
    }
  },

  components: { XIcon }
}
</script>
